var _path, _ellipse, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrateMultipleClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0127 40.1228H12.0126C4.01259 39.327 2.01259 32.4971 2.01259 29.1817C1.61259 17.6437 10.8459 14.4278 15.5126 14.2621C15.9126 8.69209 20.0126 4.97862 22.0126 3.81813C30.0126 -0.558303 36.6793 3.98397 39.0126 6.80217C51 2.49732 58.334 12.5135 57.5126 18.7379C63.9261 19.4454 66.4355 24.8768 67 29.1817C68.2 38.3324 60.1793 40.2885 56.5126 40.1228H51.5127M16.0127 40.1228V49.572L13.5127 50.5666M16.0127 40.1228H33.5127M33.5127 40.1228V57.0318M33.5127 40.1228H51.5127M51.5127 40.1228V49.572L54.0127 50.5666",
    stroke: "#092E40",
    strokeWidth: 2.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 53.7213,
    rx: 6,
    ry: 5.96787,
    fill: "#092E40"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34,
    cy: 61.6788,
    rx: 6,
    ry: 5.96787,
    fill: "#092E40"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 53.7213,
    rx: 6,
    ry: 5.96787,
    fill: "#092E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrateMultipleClouds);
export default __webpack_public_path__ + "static/media/integrate-multiple-clouds.72b96d35c809fad5f1b6a18eaee7735b.svg";
export { ForwardRef as ReactComponent };